import { Subject } from "rxjs";
import {todayDateOnly} from '../helpers/helpers';
import {fromTimeSpan, TimeSpan, toTimeSpan} from "./TimeSpan";

export class NotificationSettings {
    
    private readonly defaultBreakfastReminderHour = 10;
    private readonly defaultBreakfastReminderMinute = 0;
    private readonly defaultLunchReminderHour = 15;
    private readonly defaultLunchReminderMinute = 0;
    private readonly defaultDinnerReminderHour = 21;
    private readonly defaultDinnerReminderMinute = 0;
    
    private _trackerReminder: boolean = true;
    get trackerReminder(): boolean { return this._trackerReminder};
    set trackerReminder(value: boolean) {this._trackerReminder = value; this.changedSubject.next(true);}

    private _breakfastTrackerReminder: boolean = false;
    get breakfastTrackerReminder(): boolean { return this._breakfastTrackerReminder};
    set breakfastTrackerReminder(value: boolean) {this._breakfastTrackerReminder = value; this.changedSubject.next(true);}

    private _breakfastTime: Date = new Date(new Date().setHours(0,0,0,0));
    get breakfastTime(): Date { return this._breakfastTime };
    set breakfastTime(value: Date) {this._breakfastTime = value; this.changedSubject.next(true);}

    private _lunchTrackerReminder: boolean = false;
    get lunchTrackerReminder(): boolean { return this._lunchTrackerReminder};
    set lunchTrackerReminder(value: boolean) {this._lunchTrackerReminder = value; this.changedSubject.next(true);}

    private _lunchTime: Date = new Date(new Date().setHours(0,0,0,0));
    get lunchTime(): Date { return this._lunchTime };
    set lunchTime(value: Date) {this._lunchTime = value; this.changedSubject.next(true);}

    private _dinnerTrackerReminder: boolean = false;
    get dinnerTrackerReminder(): boolean { return this._dinnerTrackerReminder};
    set dinnerTrackerReminder(value: boolean) {this._dinnerTrackerReminder = value; this.changedSubject.next(true);}

    private _dinnerTime: Date = new Date(new Date().setHours(0,0,0,0));
    get dinnerTime(): Date { return this._dinnerTime };
    set dinnerTime(value: Date) {this._dinnerTime = value; this.changedSubject.next(true);}

    //other examples
    // recommendations: boolean = true;
    // messages: boolean = true;

    //ChangeTracking
    public changedSubject: Subject<boolean> = new Subject<boolean>();

    constructor(i?: INotificationSettings){
        if(i){
            this._trackerReminder = i.trackerReminder;
            this._breakfastTrackerReminder = i.breakfastTrackerReminder;
            this._lunchTrackerReminder = i.lunchTrackerReminder;
            this._dinnerTrackerReminder = i.dinnerTrackerReminder;
            if (i.breakfastTime) { this._breakfastTime = fromTimeSpan(i.breakfastTime); }
            else { this._breakfastTime = this.generateTime(this.defaultBreakfastReminderHour, this.defaultBreakfastReminderMinute); }
            if (i.lunchTime) { this._lunchTime = fromTimeSpan(i.lunchTime); }
            else { this._lunchTime = this.generateTime(this.defaultLunchReminderHour, this.defaultLunchReminderMinute); }
            if (i.dinnerTime) { this._dinnerTime = fromTimeSpan(i.dinnerTime); }
            else { this._dinnerTime = this.generateTime(this.defaultDinnerReminderHour, this.defaultDinnerReminderMinute); }
        }
    }

    toInterface(): INotificationSettings {
        return {
            trackerReminder: this.trackerReminder,
            breakfastTrackerReminder: this.breakfastTrackerReminder,
            lunchTrackerReminder: this.lunchTrackerReminder,
            dinnerTrackerReminder: this.dinnerTrackerReminder,
            generalTime: {hours: 20, minutes: 0, seconds: 0, milliseconds: 0},
            breakfastTime: toTimeSpan(this.breakfastTime),
            lunchTime: toTimeSpan(this.lunchTime),
            dinnerTime: toTimeSpan(this.dinnerTime)
        };
    }

    private generateTime(hour: number, minutes) {
        const date = todayDateOnly();
        date.setHours(hour);
        date.setMinutes(minutes);
        return date;
    }
}

export interface INotificationSettings {
    trackerReminder: boolean;
    breakfastTrackerReminder: boolean;
    lunchTrackerReminder: boolean;
    dinnerTrackerReminder: boolean;
    generalTime: TimeSpan;
    breakfastTime: TimeSpan;
    lunchTime: TimeSpan;
    dinnerTime: TimeSpan;
    //other examples
    // recommendations: boolean;
    // messages: boolean;
}
